export const GET_CLIENTS = "GET_CLIENTS";
export const GET_DETAIL_CLIENT = "GET_DETAIL_CLIENT";
export const GET_STATE_LOADING = "GET_STATE_LOADING";